module.exports = __webpack_public_path__ + "img/logo.4341201c.png";